import { render, staticRenderFns } from "./DepartmentsTypesConfigurationGrid.vue?vue&type=template&id=689b3022&"
import script from "./DepartmentsTypesConfigurationGrid.vue?vue&type=script&lang=js&"
export * from "./DepartmentsTypesConfigurationGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports